var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 269.605,
    viewBox: "0 0 800 269.605",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-374.431 -289.612)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(374.431 289.612)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(427.225 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.82,287.157l4.138-.012h5.834l7.377-119.832,73.052-121.9L245.045,42V33.37l-79,131.118Z",
    transform: "translate(-145.627 -33.37)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.43,300.394h5.392L182.2,180.562l73.052-121.9-3.175-3.408L176.724,178.735Z",
    transform: "translate(-152.657 -46.619)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,666.4,316.2,680.883l.162.012,183.188-11.266.138-.008v-7.736l-201.851-3.7-168.4-.162H128.2l-.134.868Z",
    transform: "translate(-126.91 -411.614)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.91,666.4,316.2,680.883l.162.012,183.188-11.266.138-.15v-7.432h-.162L316.2,668.17,129.431,658.02H129.4l-.331.217-1.006.651Z",
    transform: "translate(-126.91 -411.614)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.88,41.979l83.45,89.569L459.75,289.1l7.089.856.118.016h7.089l.848-151.658,156.262,52.2,2.635,92.937,5.7.639,1.933.217-4.473-100.239L473.6,126.715,384.036,33.6H378.88Z",
    transform: "translate(-279.485 -33.509)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.65,291.7l.643,2.9,156.262,52.2,2.635,92.937,5.7.639-4.473-95.509Z",
    transform: "translate(-425.884 -189.796)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.42,436.283l57.313,11.286.02,0,100.381,19.775,4.6-1.842-.016-.324-.3-6.41L621.479,426.05Z",
    transform: "translate(-426.35 -271.149)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.76,480.61l100.381,19.775,4.6-1.842-.016-.323Z",
    transform: "translate(-514.358 -304.187)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.49,350.56l1.55,85.34.8,43.782,7.057-.237,4.442-.15-1.381-127.5-3.061-1.018-.671-.217Z",
    transform: "translate(-520.25 -225.438)",
    fill: "#e2e8f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.65,350.51v.02l1.487,85.34.8,43.782,7.057-.237V350.51Z",
    transform: "translate(-520.347 -225.408)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.341,472.72c.126,0,.209.13.272.237a10,10,0,0,1,.824,1.578c-.462.1-1.254.209-1.483-.2C302.833,474.132,302.979,472.7,303.341,472.72Z",
    transform: "translate(-237.859 -334.028)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.387,358.04v4.749l-81.314,15.861-4.218,2.555H381.3v-2.676l79.892-19.3Z",
    transform: "translate(-300.646 -134.798)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.387,367.89l-81.314,15.861-4.218,2.555H381.3l80.485-17.225Z",
    transform: "translate(-300.646 -139.9)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.215,358.04v4.749l-19.6,1.191-.593-4.753Z",
    transform: "translate(-386.474 -134.798)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(506.661 175.682) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(497.191 167.791) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(508.239 159.899) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(527.178 152.008) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.466,
    height: 45.91,
    transform: "translate(188.948 155.154) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.466,
    height: 258.24,
    transform: "translate(184.894 114.654) rotate(-112.092)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.256,
    height: 21.985,
    transform: "translate(119.113 223.695) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 277.398,
    height: 24.571,
    transform: "translate(345.428 245.68) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.68,467.543h66.6V383.806h-49.79L133.68,426.039Z",
    transform: "translate(-20.064 -234.149)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.451,
    height: 28.451,
    transform: "translate(169.873 183.282) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.777,415.739h18.106v-28.45h-7.76Z",
    transform: "translate(-17.695 -232.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.466,
    height: 12.286,
    transform: "translate(168.579 211.733) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H.323A6.143,6.143,0,0,1,6.466,6.143h0A6.143,6.143,0,0,1,.323,12.286H0V0Z",
    transform: "translate(132.691 185.545) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H.323A6.143,6.143,0,0,1,6.466,6.143h0A6.143,6.143,0,0,1,.323,12.286H0V0Z",
    transform: "translate(373.232 233.394) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.034,660.9a31.992,31.992,0,0,0-24.867,12.378H249.53l12.286-34.223,57.225-11.286-1.617,45.509H311.9A31.992,31.992,0,0,0,287.034,660.9Z",
    transform: "translate(-199.282 -439.879)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.128,
    cy: 28.128,
    rx: 28.128,
    ry: 28.128,
    transform: "translate(58.977 213.349)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.804,
    cy: 14.804,
    rx: 14.804,
    ry: 14.804,
    transform: "translate(72.301 226.673)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.571,
    cy: 24.571,
    rx: 24.571,
    ry: 24.571,
    transform: "translate(316.654 220.139)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.932,
    cy: 12.932,
    rx: 12.932,
    ry: 12.932,
    transform: "translate(328.292 231.778)",
    fill: "#f1f5f9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.579,
    height: 97.962,
    transform: "translate(191.857 235.981) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 195.278,
    height: 5.82,
    transform: "translate(373.556 224.019) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.466,
    height: 2.586,
    transform: "translate(135.279 187.484) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.456,651.3a.647.647,0,0,1-.164-.5l8.918-84.331a.647.647,0,0,1,.64-.579h0a.647.647,0,0,1,.642.573l9.645,84.156a.647.647,0,0,1-.637.72l-18.563.175h-.006A.646.646,0,0,1,480.456,651.3Zm9.422-78.861-8.224,77.773,17.119-.161Z",
    transform: "translate(-65.84 -475.663)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H.323A6.143,6.143,0,0,1,6.466,6.143h0A6.143,6.143,0,0,1,.323,12.286H0V0Z",
    transform: "matrix(0.935, 0.354, -0.354, 0.935, 62.653, 199.674)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.466,
    height: 94.406,
    transform: "translate(427.548 106.011) rotate(180)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.053,
    cy: 9.053,
    rx: 9.053,
    ry: 9.053,
    transform: "translate(176.662 101.485)",
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(385.133 218.296) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(396.181 210.404) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(388.289 204.091) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 186.237,
    height: 7.891,
    transform: "translate(399.338 196.2) rotate(180)",
    fill: "#234ba2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 233.394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.765,681.081h-.85c.078-.184-3.7-9.847-3.7-9.847l-2.268-5.527-1.522-3.7-2.268-5.527-2.469-5.986a1.3,1.3,0,0,0-2.527,0l-2.469,5.986L257.424,662l-1.536,3.7-2.268,5.527s-3.764,9.664-3.686,9.847h-.879a2.153,2.153,0,1,0,0,4.307h28.71a2.153,2.153,0,1,0,0-4.307Z",
    transform: "translate(-246.901 -649.501)",
    fill: "#1b3c82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.126,435.7h-12l2.268-5.527h7.464Z",
    transform: "translate(-167.605 -423.192)",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.068,442.126H175.475l2.268-5.527H192.8Z",
    transform: "translate(-168.759 -420.392)",
    fill: "#f8fafc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(388.065 233.394)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.765,681.081h-.85c.078-.184-3.7-9.847-3.7-9.847l-2.268-5.527-1.522-3.7-2.268-5.527-2.469-5.986a1.3,1.3,0,0,0-2.527,0l-2.469,5.986L257.424,662l-1.536,3.7-2.268,5.527s-3.764,9.664-3.686,9.847h-.879a2.153,2.153,0,1,0,0,4.307h28.71a2.153,2.153,0,1,0,0-4.307Z",
    transform: "translate(-246.901 -649.501)",
    fill: "#1b3c82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.126,435.7h-12l2.268-5.527h7.464Z",
    transform: "translate(-167.605 -423.192)",
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.068,442.126H175.475l2.268-5.527H192.8Z",
    transform: "translate(-168.759 -420.392)",
    fill: "#f8fafc"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectEmptyState);
export default __webpack_public_path__ + "static/media/project-empty-state.89850bd129e86336bb8ba8dc087dbfa2.svg";
export { ForwardRef as ReactComponent };